/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioClickupIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-clickup-prod" */ './utils').then(
			(m) => m.ForgePioClickupIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/icon' },
);

const LazyForgePioClickupSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-clickup-prod-search-result" */ './utils').then(
			(m) => m.ForgePioClickupSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioClickupIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioClickupIconComponent />
	</Suspense>
);

export const ForgePioClickupSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioClickupSearchResultIconComponent />
	</Suspense>
);
